import { createContext } from 'react'
import Analytics from './Analytics'
/*
This file exists because both useAnalytics and AnalyticsProvider depend on it, but that can lead to circular references.
*/

const AnalyticsContext = createContext<Analytics | undefined>(undefined)

export default AnalyticsContext
